<template>
  <input
    class="border-b border-gray-300 bg-gray-50 w-full py-2 text-sm font-medium focus:outline-none"
    :value="value"
    @input="$emit('input', $event.target.value)"
    ref="input"
  />
</template>

<script>
export default {
  props: ['value'],

  methods: {
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>
